// Map of assignees to their parent departments
export const governmentHierarchy = {
  "CIA": "Central Intelligence Agency",
  "Congress": "Congress",
  "Copyright Office": "Congress",
  "Government Accountability Office": "Congress",
  "U.S. Copyright Office": "Congress",
  "Library of Congress": "Congress",
  "CFPB": "Consumer Financial Protection Bureau",
  "CPSC": "Consumer Product Safety Commission",
  "USDA": "Department of Agriculture",
  "FNS": "Department of Agriculture",
  "AgARDA": "Department of Agriculture",
  "NIST": "Department of Commerce",
  "Department of Commerce": "Department of Commerce",
  "AISI": "Department of Commerce",
  "Bureau of Industry and Security (BIS)": "Department of Commerce",
  "USPTO": "Department of Commerce",
  "National Semiconductor Technology Center": "Department of Commerce",
  "NOAA": "Department of Commerce",
  "Census Bureau": "Department of Commerce",
  "USTR": "Department of Commerce",
  "NAIC": "Department of Commerce",
  "ANSI": "Department of Commerce",
  "CHIPS Program Office": "Department of Commerce",
  "Manufacturing USA": "Department of Commerce",
  "PTO": "Department of Commerce",
  "SelectUSA": "Department of Commerce",
  "Patent and Trial Appeal Board": "Department of Commerce",
  "Foreign Commercial Service": "Department of Commerce",
  "NCI": "Department of Commerce",
  "EDA": "Department of Commerce",
  "CHIPS Manufacturing USA": "Department of Commerce",
  "End-User Review Committee": "Department of Commerce",
  "Bureau of Economic Analysis": "Department of Commerce",
  "Department of Defense": "Department of Defense",
  "DARPA": "Department of Defense",
  "DIU": "Department of Defense",
  "CDAO": "Department of Defense",
  "STTR": "Department of Defense",
  "USACE": "Department of Defense",
  "NCO": "Department of Defense",
  "USCYBERCOM": "Department of Defense",
  "CYBERCOM": "Department of Defense",
  "Army": "Department of Defense",
  "AFWERX": "Department of Defense",
  "DoD Microelectronic Commons": "Department of Defense",
  "JIATF-South": "Department of Defense",
  "Office of the Secretary of Defense": "Department of Defense",
  "Pentagon": "Department of Defense",
  "US Military": "Department of Defense",
  "SRMAs": "Department of Defense",
  "Supply Chain Center": "Department of Defense",
  "DOT&E": "Department of Defense",
  "DDS": "Department of Defense",
  "EAC": "Department of Defense",
  "Subcommittee on Machine Learning and AI": "Department of Defense",
  "Contracting Officers": "Department of Defense",
  "PACOM": "Department of Defense",
  "Army Cyber Command": "Department of Defense",
  "NCSES": "Department of Defense",
  "NCSC": "Department of Defense",
  "Team Telecom": "Department of Defense",
  "DoD Education Activity Director": "Department of Defense",
  "DoD Joint AI Center": "Department of Defense",
  "SCO": "Department of Defense",
  "Department of Education": "Department of Education",
  "IES": "Department of Education",
  "Department of Energy": "Department of Energy",
  "FERC": "Department of Energy",
  "Department of Energy (DOE)": "Department of Energy",
  "DOE National Laboratories": "Department of Energy",
  "NNSA": "Department of Energy",
  "ARPA-E": "Department of Energy",
  "DOE Office of Science": "Department of Energy",
  "DOE Grid Deployment Office": "Department of Energy",
  "DOE LPO": "Department of Energy",
  "Sandia National Laboratories": "Department of Energy",
  "FASST": "Department of Energy",
  "NREL": "Department of Energy",
  "Lawrence Livermore National Laboratory": "Department of Energy",
  "FDA": "Department of Health & Human Services",
  "NIH": "Department of Health & Human Services",
  "Department of Health and Human Services": "Department of Health & Human Services",
  "CMS": "Department of Health & Human Services",
  "ASTP": "Department of Health & Human Services",
  "ARPA-H": "Department of Health & Human Services",
  "CDC": "Department of Health & Human Services",
  "OCR": "Department of Health & Human Services",
  "BARDA": "Department of Health & Human Services",
  "HRSA": "Department of Health & Human Services",
  "Office of National Coordinator for Health Information Technology": "Department of Health & Human Services",
  "IHS": "Department of Health & Human Services",
  "ACF": "Department of Health & Human Services",
  "Department of Homeland Security": "Department of Homeland Security",
  "CISA": "Department of Homeland Security",
  "USCIS": "Department of Homeland Security",
  "DHS Science and Technology": "Department of Homeland Security",
  "CBP": "Department of Homeland Security",
  "Customs and Border Protection": "Department of Homeland Security",
  "FEMA": "Department of Homeland Security",
  "ICE": "Department of Homeland Security",
  "HSI": "Department of Homeland Security",
  "DOJ": "Department of Justice",
  "FBI": "Department of Justice",
  "Department of Justice": "Department of Justice",
  "DOJ Civil Rights Division": "Department of Justice",
  "DOL": "Department of Labor",
  "Bureau of Labor Statistics (BLS)": "Department of Labor",
  "Employment and Training Administration": "Department of Labor",
  "DOL Wage & Hours Division": "Department of Labor",
  "Department of State": "Department of State",
  "Office of the Special Envoy for Critical and Emerging Technologies": "Department of State",
  "DOI": "Department of the Interior",
  "USGS": "Department of the Interior",
  "White House Council on Native American Affairs": "Department of the Interior",
  "Treasury": "Department of the Treasury",
  "IRS": "Department of the Treasury",
  "Office of the Comptroller of the Currency": "Department of the Treasury",
  "FinCEN": "Department of the Treasury",
  "USDOT": "Department of Transportation",
  "NHTSA": "Department of Transportation",
  "FAA": "Department of Transportation",
  "Federal Motor Carrier Safety Administration (FMCSA)": "Department of Transportation",
  "DOT": "Department of Transportation",
  "ARPA-I": "Department of Transportation",
  "FHWA": "Department of Transportation",
  "Department of Treasury": "Department of Treasury",
  "Department of Veterans Affairs": "Department of Veterans Affairs",
  "Veterans Health Administration (VHA)": "Department of Veterans Affairs",
  "VHA Innovation Ecosystem": "Department of Veterans Affairs",
  "EPA": "Environmental Protection Agency",
  "EEOC": "Equal Employment Opportunity Commission",
  "OSTP": "Executive Office of the President",
  "White House": "Executive Office of the President",
  "NITRD": "Executive Office of the President",
  "OMB": "Executive Office of the President",
  "OPM": "Executive Office of the President",
  "National Artificial Intelligence Initiative Office (NAIIO)": "Executive Office of the President",
  "PCAST": "Executive Office of the President",
  "President": "Executive Office of the President",
  "NSC": "Executive Office of the President",
  "OFPP": "Executive Office of the President",
  "DOGE": "Executive Office of the President",
  "AI Czar": "Executive Office of the President",
  "CEQ": "Executive Office of the President",
  "Office of the US Trade Representative": "Executive Office of the President",
  "NEC": "Executive Office of the President",
  "AI Production Board": "Executive Office of the President",
  "EOP": "Executive Office of the President",
  "OIRA": "Executive Office of the President",
  "National Science and Technology Council": "Executive Office of the President",
  "Office of the Federal CIO": "Executive Office of the President",
  "National Security Advisor": "Executive Office of the President",
  "NERC": "Executive Office of the President",
  "Office of Federal Procurement Policy": "Executive Office of the President",
  "White House Faith Office": "Executive Office of the President",
  "WDBs": "Executive Office of the President",
  "ONC": "Executive Office of the President",
  "EXIM": "Export–Import Bank of the United States",
  "FCC": "FCC",
  "FDIC": "Federal Deposit Insurance Corporation",
  "Federal Energy Regulatory Commission": "Federal Energy Regulatory Commission",
  "Federal Reserve": "Federal Reserve",
  "Federal Trade Commission (FTC)": "Federal Trade Commission",
  "OIG": "Federal Trade Commission",
  "GSA": "General Services Administration",
  "FedRAMP": "General Services Administration",
  "Federal Acquisition Regulatory Council": "General Services Administration",
  "GSA's AI Acquisition Office": "General Services Administration",
  "Source Selection Officials": "General Services Administration",
  "OECD": "International",
  "G7": "International",
  "International bodies": "International",
  "U.S. International Development Finance Corporation (DFC)": "International Development Finance Corporation",
  "ITC": "International Trade Commission",
  "NASA": "NASA",
  "NLRB": "National Labor Relations Board",
  "National Science Foundation (NSF)": "National Science Foundation",
  "NAIRR Task Force": "National Science Foundation",
  "NTIA": "National Science Foundation",
  "NSF TIP Directorate": "National Science Foundation",
  "National Artificial Intelligence Research Institutes": "National Science Foundation",
  "NSF OSTP": "National Science Foundation",
  "NSF EDU": "National Science Foundation",
  "NSDS": "National Science Foundation",
  "National AI Institute": "National Science Foundation",
  "NSIN": "National Science Foundation",
  "National Network for Microelectronics Education": "National Science Foundation",
  "National Science Board": "National Science Foundation",
  "NSA": "National Security Agency",
  "PRISM": "National Security Agency",
  "Nuclear Regulatory Commission (NRC)": "Nuclear Regulatory Commission",
  "Intelligence Community (IC)": "Office of the Director of National Intelligence",
  "ODNI": "Office of the Director of National Intelligence",
  "IARPA": "Office of the Director of National Intelligence",
  "Secret Service": "Office of the Director of National Intelligence",
  "SEC": "Securities and Exchange Commission",
  "SBA": "Small Business Administration",
  "SBIR": "Small Business Administration",
  "State Insurance Regulators": "State Governments",
  "State Regulators": "State Governments",
  "USDS": "United States DOGE Service",
  "Development Finance Corporation": "US Development Finance Corporation",
  "USG": "Various Agencies",
  "Federal Agencies": "Various Agencies",
  "Chief Data Officers": "Various Agencies",
  "Federal Regulators": "Various Agencies",
  "Funding Agencies": "Various Agencies",
  "Law Enforcement Agencies": "Various Agencies",
  "Regulators": "Various Agencies",
  "CFIUS": "Various Agencies",
  "CHCOs": "Various Agencies",
  "Chief AI Officers": "Various Agencies",
  "CISOs": "Various Agencies",
  "Federal AI Center of Excellence": "Various Agencies",
  "NAIAC": "Various Agencies",
  "National Security Agencies": "Various Agencies",
  "Procurement Officials": "Various Agencies",
  "State Systems Offices": "Various Agencies",
  "Sector Risk Management Agencies": "Various Agencies",
  "Federal Research Agencies": "Various Agencies",
  "Financial Services Agencies": "Various Agencies",
  "National Energy Dominance Council": "Various Agencies",
  "IEEE": "Various Non-profits",
  "Center for Tribal Digital Sovereignty": "Various Non-profits",
  "RAND": "Various Non-profits"
};

// Update the topicHierarchy to be structured as topic -> array of recommendations
export const topicHierarchy = {
  "Basic Science": [
    "Increase federal funding for fundamental AI research through NSF, DOE, DARPA, and NIH",
    "Establish interdisciplinary research centers and innovation hubs for AI R&D",
    "Fund cross-agency collaborative programs for AI applications in scientific research",
    "Fund research on AI explainability, reliability, and interpretability",
    "Fund and develop standardized benchmarks and evaluation methodologies for AI in science",
    "Support research applying AI to scientific discovery (biology, materials science, climate)",
    "Advance research on AI-driven autonomous scientific experimentation",
    "Fund research integrating domain-specific scientific principles into AI models",
    "Establish prize competitions and challenges for AI breakthroughs in science",
    "Support neuro-symbolic AI and hybrid AI approaches",
    "Fund alternative approaches beyond large generative models for AI research",
    "Invest in research on AI reasoning capabilities and knowledge representation",
    "Support research on human-AI collaboration in scientific discovery",
    "Fund research on robustness and reliability of AI in scientific applications"
  ],
  "Other Sectors": [
    "Establish AI innovation hubs and testbeds for specific sectors",
    "Fund sector-specific research initiatives for AI applications",
    "Develop sector-specific AI pilot programs for real-world testing",
    "Establish public-private partnerships for sector-specific AI development",
    "Provide tax incentives and grants for sector-specific AI adoption",
    "Support AI applications for rural and underserved communities",
    "Establish federal coordination mechanisms for sector-specific AI initiatives",
    "Develop AI-powered emergency and disaster response systems",
    "Support AI integration in transportation and autonomous vehicles"
  ],
  "Standards and Regulations": [
    "Enact comprehensive national AI risk management legislation",
    "Implement mandatory AI impact assessments and testing requirements",
    "Create AI security standards for high-risk applications",
    "Establish a federal AI regulatory body with enforcement authority",
    "Require transparency in AI systems through standardized disclosures",
    "Develop mandatory explainability standards for AI decision-making",
    "Implement national AI licensing requirements",
    "Mandate human oversight for high-risk AI applications",
    "Implement comprehensive data governance regulations for AI",
    "Establish mandatory incident reporting requirements for AI failures",
    "Develop federal standards for algorithmic fairness and bias mitigation",
    "Establish AI liability requirements for developers",
    "Require mandatory content authentication for AI-generated media",
    "Develop sector-specific AI regulatory frameworks",
    "Promote international harmonization of AI standards"
  ],
  "Export Controls": [
    "Increase funding for the Bureau of Industry and Security (BIS)",
    "Expand export controls to include advanced inference chips",
    "Implement location tracking and verification systems for AI chips",
    "Reassess and update country tier classifications in the AI Diffusion Framework",
    "Coordinate export control policies multilaterally with allies",
    "Exclude open-source AI models from export controls",
    "Legislate to include cloud computing services in export control regime",
    "Implement conditional export controls based on security features",
    "Streamline export licensing for trusted partners and entities"
  ],
  "Infrastructure": [
    "Streamline permitting processes for energy infrastructure",
    "Fund and expand the National AI Research Resource (NAIRR)",
    "Increase investment in domestic semiconductor manufacturing",
    "Develop nuclear power for AI data centers",
    "Create tax incentives for AI infrastructure development",
    "Establish public-private partnerships for AI infrastructure",
    "Modernize the electrical grid to support AI data centers",
    "Expand high-speed broadband and fiber infrastructure for AI",
    "Fund research on energy-efficient AI models and systems",
    "Support AI infrastructure development in rural and underserved areas",
    "Implement security standards for AI data centers",
    "Create standards for AI interoperability",
    "Support development of advanced cooling technologies for data centers",
    "Establish 'Special Compute Zones' on federal lands",
    "Designate AI data centers as critical infrastructure"
  ],
  "Security": [
    "Establish Comprehensive AI Security Standards",
    "Fund Research and Development in AI Security Technologies",
    "Implement Mandatory Red-Teaming for Advanced AI Systems",
    "Designate Advanced AI Infrastructure as Critical Infrastructure",
    "Create a Public-Private AI Security Information Sharing System",
    "Establish Security Standards for AI Hardware and Supply Chains",
    "Establish an AI Safety/Security Institute with Enhanced Authority",
    "Enhance Security Clearance Processes for AI Researchers/Developers",
    "Create Secure Computing Environments for Classified AI Research",
    "Implement AI Model Registration and Tracking Systems",
    "Leverage AI for Enhanced Cybersecurity of Critical Infrastructure",
    "Create Special Compute Zones with Enhanced Security"
  ],
  "Biosecurity": [
    "Strengthen DNA Synthesis Screening and Verification",
    "Develop and Enforce Model Evaluation Standards",
    "Implement Access Controls for Dual-Use AI in Biology",
    "Lead International Coordination on AI Biosecurity Standards",
    "Fund Research for AI Safety in Biology",
    "Mandate Technical Safeguards for Biologically-Capable AI Systems"
  ],
  "Healthcare": [
    "Establish Risk-Based Regulatory Frameworks",
    "Develop Clinical AI Explainability Standards for Healthcare Providers",
    "Create Reimbursement Pathways for AI-Enabled Healthcare",
    "Fund AI-Specific Healthcare Research and Development",
    "Mandate Healthcare AI Training on Diverse Patient Datasets",
    "Develop Healthcare-Specific AI Data Privacy Protections",
    "Create Healthcare AI Workforce Development Programs",
    "Establish Federal Healthcare Data Interoperability Standards",
    "Mandate Post-Deployment Clinical AI Monitoring Systems",
    "Establish Clear AI Liability Frameworks",
    "Create Medical AI Testing Environments in Healthcare Systems",
    "Develop Standardized Medical Reference Datasets for AI Validation",
    "Prohibit Automated Medical Denials Without Human Review"
  ],
  "Procurement": [
    "Streamline the FedRAMP/ATO process for AI technologies to enable faster adoption",
    "Expand use of Other Transaction Authorities (OTAs) and flexible contracting vehicles for acquiring AI technologies",
    "Create centralized AI-specific marketplaces and acquisition platforms with pre-vetted vendors",
    "Shift from traditional contracting to outcome-based/performance-based models for AI procurement",
    "Adopt commercial industry-standard terms, conditions, and licensing models for government AI procurement",
    "Establish AI-specific procurement guidelines and standards that consider unique aspects of AI systems",
    "Create procurement preferences, set-asides, or simplified pathways for small businesses and non-traditional AI vendors",
    "Mandate transparency requirements for AI vendors regarding training data, model architecture, and explainability in procurement",
    "Establish mechanisms for sharing AI procurement best practices, lessons learned, and expertise across agencies",
    "Create structured AI pilot programs with clear criteria for transitioning successful pilots to full procurement",
    "Require human oversight, review, and accountability when AI systems are used in procurement processes",
    "Establish procurement preferences for domestically developed AI solutions to strengthen security and industry",
    "Develop standardized procurement frameworks and processes for evaluating and testing AI models during acquisition"
  ],
  "Deregulation": [
    "Implement federal preemption of state AI laws to create a unified national framework",
    "Streamline environmental permitting and infrastructure approvals for AI data centers",
    "Apply risk-based regulatory approach to AI with minimal oversight for low-risk applications",
    "Establish regulatory sandboxes for testing AI innovations with temporary regulatory relief",
    "Clarify how existing laws apply to AI rather than creating new AI-specific regulations",
    "Streamline government procurement and Authority to Operate processes for AI technologies",
    "Create safe harbors from liability for AI developers and deployers following best practices",
    "Focus regulation on AI uses and outcomes rather than the underlying technology",
    "Harmonize international AI regulations to reduce compliance burdens",
    "Reform copyright rules to clarify that AI training falls under fair use",
    "Reduce export controls on AI systems and hardware to expand global market access"
  ],
  "Open Source": [
    "Fund open source AI model development and maintenance",
    "Establish a national repository for open source AI models and datasets",
    "Require federally funded AI research to be open source",
    "Develop open source AI interoperability standards and frameworks",
    "Create risk-based security guidelines for open source AI models",
    "Allocate compute resources for open source AI development",
    "Establish public-private partnerships for open source AI development",
    "Conduct rigorous assessments of open source AI benefits and risks",
    "Launch open source AI prize competitions and challenges"
  ],
  "Finance": [
    "Enhance consumer financial data sharing and protection frameworks",
    "Implement AI-powered financial crime detection infrastructure",
    "Modernize insurance regulation for AI implementation",
    "Transform financial regulatory compliance with AI"
  ],
  "Evidence of Risks": [
    "Establish mandatory AI incident reporting systems",
    "Develop standardized AI safety and performance evaluation frameworks",
    "Mandate AI explainability requirements for high-risk applications",
    "Implement risk-based regulatory frameworks for AI systems",
    "Fund research on AI interpretability and mechanistic transparency",
    "Require comprehensive red-teaming for high-risk AI models",
    "Create continuous monitoring requirements for deployed AI systems",
    "Establish protections for AI whistleblowers",
    "Create data provenance and watermarking requirements for AI systems",
    "Require specialized testing for AI capabilities with national security implications",
    "Create AI safety testbeds and regulatory sandboxes",
    "Mandate independent third-party audits for high-risk AI systems",
    "Strengthen the U.S. AI Safety Institute (AISI) for model evaluation and risk assessment",
    "Require impact assessments before AI deployment in critical sectors"
  ],
  "Ethics & Civil Rights": [
    "Mandate AI transparency and explainability requirements",
    "Establish comprehensive data privacy frameworks for AI",
    "Require AI bias testing and mitigation measures",
    "Mandate human oversight for high-consequence AI decisions",
    "Create AI governance boards and ethics committees",
    "Require AI impact assessments for high-risk applications",
    "Establish clear AI accountability and liability frameworks",
    "Require disclosure of AI-generated content",
    "Protect children from AI-related harms",
    "Ensure AI accessibility and inclusivity for diverse populations",
    "Respect Indigenous data sovereignty in AI development",
    "Combat harmful AI-generated deepfakes",
    "Require representative training data in AI systems"
  ],
  "Military": [
    "Streamline AI acquisition and procurement processes for defense applications",
    "Establish secure infrastructure for classified AI development and deployment",
    "Invest in edge AI and unmanned vehicles for contested environments",
    "Expand public-private partnerships for defense AI innovation",
    "Develop AI-specific testing, evaluation, and red team frameworks for military applications",
    "Develop ethical guidelines and human oversight frameworks for military AI",
    "Fund specialized military AI research through DARPA and national labs",
    "Implement AI for intelligence analysis and predictive capabilities",
    "Establish international military AI cooperation frameworks with allies",
    "Establish clear DoD policy for human oversight in autonomous weapons systems"
  ],
  "Market Impacts": [
    "Strengthen antitrust enforcement in AI markets",
    "Prohibit cloud data egress fees",
    "Mandate AI model interoperability",
    "Facilitate non-dilutive funding for AI startups",
    "Prohibit anti-competitive self-preferencing by dominant platforms",
    "Implement AI agent access rights to digital platforms",
    "Establish collective data bargaining structures"
  ],
  "Data & IP": [
    "Establish a comprehensive federal data privacy law with state preemption",
    "Clarify that AI training on publicly available data falls under fair use doctrine",
    "Implement mandatory transparency requirements for AI training data sources",
    "Create a market-based licensing framework for AI training on copyrighted works",
    "Mandate content provenance systems for AI-generated outputs",
    "Develop standardized data formats and interoperability frameworks for AI",
    "Establish a National AI Data Repository for public datasets",
    "Invest in privacy-enhancing technologies (PETs) for AI development",
    "Develop copyright guidelines for AI-assisted or AI-generated works",
    "Create opt-in/opt-out mechanisms for content creators regarding AI training",
    "Foster cross-border data flows for AI development",
    "Expand access to government-held datasets for AI training",
    "Create guidelines for AI intellectual property protection and patents"
  ],
  "Talent & Education": [
    "Establish comprehensive K-12 AI literacy programs and curriculum integration",
    "Create industry-academic partnerships for AI workforce development",
    "Expand AI-focused professional development for educators",
    "Develop targeted immigration reforms to attract and retain AI talent",
    "Fund AI research and training initiatives at universities",
    "Create federal AI reskilling and upskilling programs for displaced workers",
    "Implement AI talent initiatives for federal government workforce",
    "Establish AI certification programs and credentials",
    "Support community colleges and technical schools in AI education",
    "Create tax incentives for companies investing in AI training",
    "Fund AI apprenticeship programs",
    "Develop AI education programs for underrepresented groups",
    "Support AI scholarship and fellowship programs",
    "Create AI literacy programs for small businesses"
  ],
  "Global Engagement": [
    "Lead international AI standards development",
    "Promote cross-border data flows for AI development",
    "Establish strategic bilateral AI partnerships",
    "Expand international AI research collaborations",
    "Strengthen NIST's global leadership in AI governance",
    "Counter Chinese AI influence in emerging markets",
    "Pursue formal treaties and trade agreements on AI",
    "Create a global network of AI safety institutes",
    "Represent U.S. interests in multilateral organizations",
    "Develop AI capacity building programs for developing nations",
    "Push back against restrictive EU AI regulations"
  ]
}; 